var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCnx(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    fill: "#4c6bae",
    r: 16
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.383 17.01L5 17.153c.74-2.07 2.203-3.726 4.391-4.968.207 1.716 1.02 3.135 2.44 4.259l-1.3.135a5.503 5.503 0 004.553 4.845 6.084 6.084 0 01-2.987 1.185c.681 1.2 1.487 2.183 2.417 2.947a9.674 9.674 0 01-8.131-8.546zm19.234-2.02L27 14.847c-.74 2.07-2.203 3.726-4.391 4.968-.207-1.716-1.02-3.135-2.44-4.259l1.3-.135a5.503 5.503 0 00-4.626-4.857 6.085 6.085 0 012.972-1.173c-.687-1.209-1.499-2.196-2.438-2.963a9.674 9.674 0 018.24 8.562z",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.922 25.626L17.065 27c-2.07-.74-3.726-2.203-4.968-4.391 1.715-.207 3.134-1.02 4.258-2.44l.136 1.31a5.503 5.503 0 004.945-4.636 6.085 6.085 0 011.173 2.972c1.209-.687 2.196-1.499 2.963-2.438a9.674 9.674 0 01-8.65 8.249zM14.99 6.383L14.847 5c2.07.74 3.726 2.203 4.968 4.391-1.716.207-3.135 1.02-4.259 2.44l-.135-1.3a5.503 5.503 0 00-4.857 4.626 6.085 6.085 0 01-1.173-2.972c-1.209.687-2.196 1.499-2.963 2.438a9.674 9.674 0 018.562-8.24z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCnx);
export default __webpack_public_path__ + "static/media/cnx.db98c7f974648614a048a62b0eba0a7a.svg";
export { ForwardRef as ReactComponent };